/**
 * Helper compartido: lista de herramientas por plan.
 * Fuente de verdad ÚNICA = WINDOWS_CONFIG (WindowManager.jsx).
 *
 * Uso:
 *   import { buildPlanTools } from '@/utils/planTools';
 *   const { free, pro, ultimate } = buildPlanTools();
 */
import { WINDOWS_CONFIG } from '@/components/WindowManager';

// Nivel del plan (basic == pro, premium == ultimate)
const PLAN_LEVEL = { free: 0, basic: 1, pro: 1, premium: 2, ultimate: 2 };

let _cache = null;

export const buildPlanTools = () => {
  if (_cache) return _cache;

  const seen = new Set();
  const tools = [];
  for (const w of WINDOWS_CONFIG) {
    const name = (w.fullName || w.name || '').trim();
    if (!name || seen.has(name)) continue;
    seen.add(name);
    tools.push({
      id: w.id,
      name,
      description: w.description || '',
      requiredLevel: PLAN_LEVEL[w.requiredPlan || 'free'] ?? 0,
    });
  }
  tools.sort((a, b) => a.name.localeCompare(b.name, 'es'));

  _cache = {
    free: tools.filter(t => t.requiredLevel === 0),
    pro: tools.filter(t => t.requiredLevel <= 1),
    ultimate: tools,
  };
  return _cache;
};

export default buildPlanTools;
